import React, { Component } from 'react'
import NewElementObject from './newElementObject/newElementObject'
import LayoutHolder from './layoutHolder/layoutHolder'
import BlockHolder from './blockHolder/blockHolder'
import { Tooltip } from 'react-tooltip'
import { connect } from 'react-redux';
import i18n from '~/i18n'
import Icons from '~/Common-Objects/UI/Icons/index'
import TierLimitHolder from '~/Common-Objects/UI/Cards/TierLimitHolder'
import axios from '../../../../../../../data/http/axios'

//CONNECT TO STORE 
@connect((store) => {
    return { siteMaster: store.siteMaster }
})


export default class ElementPicker extends Component {
    constructor(props) {
        super(props)
        this.state = { permissions: null }

        this.insertElement = this.insertElement.bind(this);
        //when we are pulling element from DB inser the elementID below (Hardcoded to 0 for now)
    }

    componentDidMount() {
        axios.get('/accountMaster/tier/customTemplateBlocks').then(res => {
            this.setState({ permissions: res.data })
        })
    }

    insertElement(theEl) {
        this.props.insertElement(theEl.content);
    }

    renderTooltips(items, idPrefix) {
        return items.map((item, index) => (
            <Tooltip key={idPrefix + index} id={idPrefix + index} className="tooltip green" />
        ));
    }

    render() {

        if (this.props.type == "element") {
            const elements = this.props.components.filter(theC => { if (!theC.marketPlace || theC.marketPlace == 0) return true });
            return <div>
                {elements.map((thisEl, index) => {
                    if (thisEl.category === "element") {
                        return <div key={"newEl-" + index} data-tooltip-content={thisEl.title} data-tooltip-id={"newEl-" + index} className="lElementHolder" data-ph={`dragdrop-element-${(thisEl.title || '').toString().toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/(^-|-$)/g,'')}`} onClick={() => { this.insertElement(thisEl) }}>
                            <NewElementObject id={"newEl-" + index} title={thisEl.title} content={thisEl.content} toolbarIcon={thisEl.toolbarIcon} element={thisEl} />
                        </div>
                    }
                })}
                {!this.props.isForm &&
                    <div onClick={this.props.openMarket} className="lElementHolder" style={{ marginTop: "20px" }}>
                        <div className="newElementObject" style={{ justifyContent: "center", alignItems: "center" }}>
                            <Icons className="newElementObject-icon" style={{ margin: '2px 5px 0 0' }} icon="shoppingbag" />
                            <div className="newElementObject-text text-primary text-heavy">App Market</div>
                        </div>
                    </div>
                }
                {/* Render tooltips for elements */}
                {this.renderTooltips(elements.filter(el => el.category === "element"), "newEl-")}
            </div>
        }

        if (this.props.type == "layout") {
            return <div>
                {this.props.components.map((thisEl, index) => {
                    return <div key={"newLay-" + index} data-tooltip-content={thisEl.title} data-tooltip-id={"newLay-" + index} className="lElementHolder" data-ph={`dragdrop-layout-${(thisEl.title || '').toString().toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/(^-|-$)/g,'')}`} onClick={() => { this.insertElement(thisEl) }}>
                        <LayoutHolder id={"newHL-" + index} title={thisEl.title} content={thisEl.content} toolbarIcon={thisEl.toolbarIcon} />
                    </div>
                })}
                {/* Render tooltips for layouts */}
                {this.renderTooltips(this.props.components, "newLay-")}
            </div>
        }
        if (this.props.type == "block") {
            return <div>
                {this.props.components.map((thisEl, index) => {
                    return <div key={"newLay-" + index} data-tooltip-content={thisEl.title} data-tooltip-id={"newLay-block-" + index} className="lElementHolder" data-ph={`dragdrop-block-${(thisEl.title || '').toString().toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/(^-|-$)/g,'')}`} onClick={() => { this.insertElement(thisEl) }}>
                        <BlockHolder id={"newHL-" + index} title={thisEl.title} content={thisEl.content} toolbarIcon={thisEl.toolbarIcon} />
                    </div>
                })}
                {/* Render tooltips for blocks */}
                {this.renderTooltips(this.props.components, "newLay-block-")}
            </div>
        }

        if (this.props.type == "userBlock" && this.state.permissions) {
            if (this.state.permissions.err && this.state.permissions.err === 'tierForbids') {
                return <TierLimitHolder {...this.state.permissions} type="Saved Blocks" small={true} />
            }
            if (!this.props.components || !this.props.components.length) {
                return <div>
                    <div className="text-sml text-heavy mar-b10">{i18n.t('templates:add.drag.block.noBlocks')}</div>
                    <p className="text-sml">{i18n.t('templates:add.drag.block.noBlocksDetail')}</p>
                </div>
            }
            return <div>
                {this.props.components.map((thisEl, index) => {
                    return <div key={"newLay-" + index} data-tooltip-content={thisEl.title} data-tooltip-id={"newLay-user-" + index} className="lElementHolder" data-ph="dragdrop-saved-layout" onClick={() => { this.insertElement(thisEl) }}>
                        <BlockHolder type="userBlock" id={"newHL-" + index} title={thisEl.title} content={thisEl.content} toolbarIcon={thisEl.toolbarIcon} blockId={thisEl.componentId} updateBlocks={this.props.updateBlocks} />
                    </div>
                })}
                {/* Render tooltips for user blocks */}
                {this.renderTooltips(this.props.components, "newLay-user-")}
            </div>
        }

        return <div></div>
    }
}


